export default "__VITE_ASSET__b78a4ead__"